import { useEffect, useState } from 'react';

import { api } from './api.js';

export interface BranchOption {
  id: string;
  name: string;
}

export interface BranchScope {
  /** Active warehouses (= branches) this person may use — already narrowed by the server. */
  branches: BranchOption[];
  /**
   * The branches this person is confined to, or null when unrestricted (the
   * owner, anyone with no branch ticked in Settings → Users).
   */
  allowed: string[] | null;
  loaded: boolean;
}

/**
 * Who am I, branch-wise? One read of `GET /warehouses`, which answers with the
 * caller's own branches plus `allowedWarehouseIds` (null = unrestricted).
 */
export function useBranchScope(): BranchScope {
  const [state, setState] = useState<BranchScope>({ branches: [], allowed: null, loaded: false });
  useEffect(() => {
    let on = true;
    void api()
      .get<{ items: Array<{ id: string; name: string; isActive: boolean }>; allowedWarehouseIds?: string[] | null }>('/warehouses')
      .then((r) => {
        if (!on) return;
        setState({
          branches: r.data.items.filter((w) => w.isActive).map((w) => ({ id: w.id, name: w.name })),
          allowed: r.data.allowedWarehouseIds ?? null,
          loaded: true,
        });
      })
      .catch(() => { if (on) setState((s) => ({ ...s, loaded: true })); });
    return () => { on = false; };
  }, []);
  return state;
}
